// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Kzse","col":"styles_col__3pVw5","actions":"styles_actions__2B2oH","conflict":"styles_conflict__2Bq8h"};